<template>
	<div class="top" style="background-color: #f5f5f5;padding-bottom: 20px;">
		<div class="header">
			<h2 style="padding: 10px 5px;">新增监测设备</h2>
		</div>
		<div class="middle-row around" style="width: 100%;">
			<div class="subinput middle-row around">
				<div class="input-group">
					<span class="input-group-addon">设备类型</span>
					<select name="" id="select" v-model="equType" class="form-control">
						<option v-for="(target, i) in selected" :value="target.name" :key='i'>{{ target.name }}</option>
					</select>
				</div>
			</div>
			<div class="subinput middle-row around">
				<div class="input-group">
					<span class="input-group-addon">企业名称</span>
					<input type="text" v-model="enterpriseName" class="form-control" placeholder="所属企业">
				</div>
			</div>
			<div class="subinput middle-row around">
				<div class="input-group">
					<span class="input-group-addon">设备编号</span>
					<input type="text" v-model="equNum" class="form-control" placeholder="设备编号">
				</div>
			</div>
			<div class="subinput middle-row around">
				<div class="input-group">
					<span class="input-group-addon">所属街道</span>
					<select name="" id="select" v-model="street" class="form-control">
						<option value="东山街道">东山街道</option>
						<option value="南黎街道">南黎街道</option>
						<option value="曲阳街道">曲阳街道</option>
						<option value="渠沟镇">渠沟镇</option>
						<option value="任圩街道">任圩街道</option>
						<option value="三堤口">三堤口</option>
						<option value="相南街道">相南街道</option>
						<option value="相山东街道">相山东街道</option>
						<option value="相山西街道">相山西街道</option>
						<option value="凤凰山经济开发区">凤凰山经济开发区</option>
					</select>
				</div>
			</div>
			<div class="subinput middle-row around">
				<div class="input-group">
					<span class="input-group-addon">业主名称</span>
					<input type="text" v-model="owner" class="form-control" placeholder="业主名称">
				</div>
			</div>
			<div class="subinput middle-row around">
				<div class="input-group">
					<span class="input-group-addon">联系电话</span>
					<input type="text" v-model="phone" class="form-control" placeholder="联系电话">
				</div>
			</div>
		</div>
		<div class="map middle-row around" style="height: 660px;margin-top: 20px;">
			<div class="left" style="width: 63%;height: 660px;background-color: white;border: 3px solid white;">
				<baidu-map style="height:654px;" class="bm-view" :zoom='zoom' @zoomend="zoomEnd" :center="center"
					ak="zqBjGlhZHNC8xz8h0gEmaYPROCXpIK0O" :scroll-wheel-zoom='true' @moveend="getCenter">
					<bm-marker :position="center" :dragging="false" animation="BMAP_ANIMATION_BOUNCE">
					</bm-marker>
				</baidu-map>
			</div>
			<div class="right middle-column around" style="width: 30%;height: 100%;background-color: white;">

				<h4 style="width: 80%;text-align: left;">企业名称:{{ enterpriseName }}</h4>
				<h4 style="width: 80%;text-align: left;">设备类型:{{ equType }}</h4>
				<h4 style="width: 80%;text-align: left;">设备编号:{{ equNum }}</h4>
				<h4 style="width: 80%;text-align: left;">所属街道:{{ street }}</h4>
				<h4 style="width: 80%;text-align: left;">业主名称:{{ owner }}</h4>
				<h4 style="width: 80%;text-align: left;">联系电话:{{ phone }}</h4>
				<div class="input-group" style="width: 80%;">
					<span class="input-group-addon">经度</span>
					<input type="text" v-model="center.lat" class="form-control" placeholder="所属企业" disabled="disabled">
				</div>
				<div class="input-group" style="width: 80%;">
					<span class="input-group-addon">纬度</span>
					<input type="text" v-model="center.lng" class="form-control" placeholder="所属企业" disabled="disabled">
				</div>
				<div class="middle-row around">
					<button type="button" class="btn btn-success" @click="saveEqu">保存设备</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	BaiduMap,
	BmMarker,
	BmCircle
} from 'vue-baidu-map'

export default {
	data() {
		return {
			selected: [{
				name: '餐饮油烟排放',
				files: ['油烟浓度', '颗粒物浓度', '非甲烷总烃'],
				type: 'lampblack'
			}, {
				name: 'VOCS排放',
				files: ['VOCS排放'],
				type: 'outdoor'
			}, {
				name: '工地扬尘',
				files: ['pm2.5', 'pm10', '噪声', '温度', '湿度', '风力', '风向', '风速'],
				type: 'dust'
			}, {
				name: '工业企业废气',
				files: ['苯', '苯系物', '非甲烷总烃', '温度', '颗粒物'],
				type: 'carrepair'
			}],
			selectedindex: 0,
			equType: '',
			enterpriseName: '',
			equNum: '',
			center: {
				lng: 116.811642,
				lat: 33.970323
			},
			zoom: 14,
			street: '',
			owner: '',
			phone: ''
		}
	},
	methods: {
		getCenter: function (e) {
			console.log(e.target.se.lat,e.target.se.lng)
			this.center.lat = e.target.se.lat;
			this.center.lng = e.target.se.lng;
		},
		zoomEnd: function (type, target) {
			this.zoom = type.target.Na;
			console.log(this.zoom)
		},
		saveEqu: function () {
			if (this.equType == '' || this.enterpriseName == '' || this.equNum == '') {
				alert("请填写所有信息后再提交!");
				return;
			} else {
				if (confirm('请再次核对，确保信息无误！')) {
					var merchant = {};

					merchant.equType = this.equType;
					merchant.equNum = this.equNum;
					merchant.merchantName = this.enterpriseName;
					merchant.longitude = this.center.lng;
					merchant.latitude = this.center.lat;
					merchant.state = "offline";
					merchant.street = this.street;
					merchant.owner = this.owner;
					merchant.phone = this.phone;

					this.$http.get(this.GLOBAL.base + 'saveEqu', {
						params: merchant
					}).then(function (res) {
						alert(res.body.msg);
					}, function (error) {

					})
				}
			}
		}
	},
	components: {
		BaiduMap,
		BmMarker,
		BmCircle
	},
}
</script>

<style>
.subinput {
	width: 16% !important;
}
</style>
